import React from 'react';
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider } from './contexts/LanguageContext';
import { AdminAuthProvider } from './contexts/AdminAuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import AdminLayout from './components/AdminLayout';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import Services from './pages/Services';
import Blog from './pages/Blog';
import Contact from './pages/Contact';
import AdminLogin from './pages/admin/AdminLogin';
import Dashboard from './pages/admin/Dashboard';
import AdminProfile from './pages/admin/AdminProfile';
import AdminsManager from './pages/admin/AdminsManager';
import ContactsManager from './pages/admin/ContactsManagerEnhanced';
import NewsletterManager from './pages/admin/NewsletterManager';
import BlogManager from './pages/admin/BlogManager';
import UsersManager from './pages/admin/UsersManagerEnhanced';
import ClientUsersManager from './pages/admin/ClientUsersManager';
import DocumentsManager from './pages/admin/DocumentsManager';
import PaymentsManager from './pages/admin/PaymentsManagerEnhanced';
import InvoicesManager from './pages/admin/InvoicesManager';
import PaymentSettings from './pages/admin/PaymentSettings';
import PaymentCheckout from './pages/PaymentCheckout';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import PayPalSuccess from './pages/PayPalSuccess';
import PayPalCancel from './pages/PayPalCancel';
import ClientLogin from './pages/client/ClientLogin';
import ClientDashboard from './pages/client/ClientDashboard';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <AdminAuthProvider>
          <LanguageProvider>
            <Toaster position="top-right" />
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={
                <>
                  <Navbar />
                  <Home />
                  <Footer />
                </>
              } />
              <Route path="/services" element={
                <>
                  <Navbar />
                  <Services />
                  <Footer />
                </>
              } />
              <Route path="/blog" element={
                <>
                  <Navbar />
                  <Blog />
                  <Footer />
                </>
              } />
              <Route path="/contact" element={
                <>
                  <Navbar />
                  <Contact />
                  <Footer />
                </>
              } />

              {/* Payment Routes */}
              <Route path="/payment" element={
                <>
                  <Navbar />
                  <PaymentCheckout />
                  <Footer />
                </>
              } />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/payment/paypal/success" element={<PayPalSuccess />} />
              <Route path="/payment/paypal/cancel" element={<PayPalCancel />} />

              {/* Client Routes */}
              <Route path="/client/login" element={<ClientLogin />} />
              <Route path="/client/dashboard" element={<ClientDashboard />} />

              {/* Admin Routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={
                <ProtectedRoute>
                  <AdminLayout>
                    <Dashboard />
                  </AdminLayout>
                </ProtectedRoute>
              } />
              <Route path="/admin/profile" element={
                <ProtectedRoute>
                  <AdminLayout>
                    <AdminProfile />
                  </AdminLayout>
                </ProtectedRoute>
              } />
              <Route path="/admin/admins" element={
                <ProtectedRoute>
                  <AdminLayout>
                    <AdminsManager />
                  </AdminLayout>
                </ProtectedRoute>
              } />
              <Route path="/admin/contacts" element={
                <ProtectedRoute>
                  <AdminLayout>
                    <ContactsManager />
                  </AdminLayout>
                </ProtectedRoute>
              } />
              <Route path="/admin/newsletter" element={
                <ProtectedRoute>
                  <AdminLayout>
                    <NewsletterManager />
                  </AdminLayout>
                </ProtectedRoute>
              } />
              <Route path="/admin/blog" element={
                <ProtectedRoute>
                  <AdminLayout>
                    <BlogManager />
                  </AdminLayout>
                </ProtectedRoute>
              } />
              <Route path="/admin/users" element={
                <ProtectedRoute>
                  <AdminLayout>
                    <UsersManager />
                  </AdminLayout>
                </ProtectedRoute>
              } />
              <Route path="/admin/client-users" element={
                <ProtectedRoute>
                  <AdminLayout>
                    <ClientUsersManager />
                  </AdminLayout>
                </ProtectedRoute>
              } />
              <Route path="/admin/documents" element={
                <ProtectedRoute>
                  <AdminLayout>
                    <DocumentsManager />
                  </AdminLayout>
                </ProtectedRoute>
              } />

              <Route path="/admin/payments" element={
                <ProtectedRoute>
                  <AdminLayout>
                    <PaymentsManager />
                  </AdminLayout>
                </ProtectedRoute>
              } />
              <Route path="/admin/invoices" element={
                <ProtectedRoute>
                  <AdminLayout>
                    <InvoicesManager />
                  </AdminLayout>
                </ProtectedRoute>
              } />
              <Route path="/admin/payment-settings" element={
                <ProtectedRoute>
                  <AdminLayout>
                    <PaymentSettings />
                  </AdminLayout>
                </ProtectedRoute>
              } />
            </Routes>
          </LanguageProvider>
        </AdminAuthProvider>
      </Router>
    </HelmetProvider>
  );
}

export default App;
